<template>
    <div ref="tools">
        <div class="corners tools">
            <div class="top left" @pointerdown.stop="startDragAfileSize(ORIGIN_TYPE.TOP_LEFT, $event)"></div>
            <div class="top right" @pointerdown.stop="startDragAfileSize(ORIGIN_TYPE.TOP_RIGHT, $event)"></div>
            <div class="bottom left" @pointerdown.stop="startDragAfileSize(ORIGIN_TYPE.BOTTOM_LEFT, $event)"></div>
            <div class="bottom right" @pointerdown.stop="startDragAfileSize(ORIGIN_TYPE.BOTTOM_RIGHT, $event)"></div>
        </div>
        <div class="close-btns tools" @click.stop="closeAFile" @pointerdown.stop="">
            <div class="left"></div>
            <div class="right"></div>
        </div>
        <div class="window-btns tools" :class="windowBtnClass" @click="handleWindow">
            <div class="left"></div>
            <div class="right"></div>
        </div>
    </div>
</template>
<script>
import EventBus from '../../js/event_bus.js'
import { store } from '../../store';
import { settingStore } from '../../js/store/settingStore';
import { EVENT_TYPE } from '../../js/event/event';
import { focusStore } from '../../js/store/nowFocusStore';
import { windowContentScaleX, windowContentScaleY } from '../../js/common/content_scale';
import { afileStore } from '../../js/store/afileStore';
import AFileControl from '../../js/afile_control';
import { PAGE_TAG } from '../../js/page_loader/page_tag';
import { bookPageStore } from '../../js/store/bookPageStore';
import PainterProxy from '@/js/painter/proxy';

const ORIGIN_TYPE = {
    TOP_LEFT: 0,
    TOP_RIGHT: 1,
    BOTTOM_LEFT: 2,
    BOTTOM_RIGHT: 3
}

const MIN_WINDOW_SCALE = {
    AFILE: 0.4,
    AFILE_MOVIE: 0.5,
    AFILE_IMAGE: 0.5
}

export default {
    name: 'AFileTool',
    data: function () {
        return {
            top: 0,
            left: 0,
            width: 1920,
            height: 1017,
            deltaMouse: { x: 0, y: 0 },
            resizeOrigin: "",
            maxWidth: window.globalThis.pageWidth,
            maxHeight: window.globalThis.pageHeight,
            maximum: true,
            store,
            pointerType: "",
            ORIGIN_TYPE,
            minScale: 0.5,
            originWidth: 0,
            originHeight: 0
        }
    },
    props: [
        "AFileConfig",
        "parentWindow"
    ],
    methods: {
        startDragAfileSize: function (resizeOrigin, e) {
            this.pointerType = e.pointerType;
            e.stopPropagation();
            this.resizeOrigin = resizeOrigin;
            this.deltaMouse.x = e.clientX / store.contentScale;
            this.deltaMouse.y = e.clientY / store.contentScale;

            this.left = this.parentWindow.left;
            this.top = this.parentWindow.top;
            this.width = this.parentWindow.width;
            this.height = this.parentWindow.height;

            console.log("start drag", e.clientX)
            document.addEventListener(EVENT_TYPE.get(this.pointerType + ":move"), this.dragAfileSize);
            document.addEventListener(EVENT_TYPE.get(this.pointerType + ":up"), this.endDragAfileSize);

            console.log(">>>", this.AFileWindowMaxWidth);
        },
        dragAfileSize: function (e) {
            if(afileStore.maximum) {
                afileStore.maximum = false;
                bookPageStore.isHidden = false;
            }
            let deltaX, deltaY;
            if (e.type === "mousemove" || e.type === "pointermove") {
                deltaX = (e.clientX / store.contentScale - this.deltaMouse.x);
                deltaY = (e.clientY / store.contentScale - this.deltaMouse.y);
            } else {
                deltaX = (e.touches[0].screenX / store.contentScale - this.deltaMouse.x);
                deltaY = (e.touches[0].screenY / store.contentScale - this.deltaMouse.y);
            }
            let predictWidth = this.width;
            let predictHeight = this.height;
            let predictLeft = this.left;
            let predictTop = this.top;

            // 從左邊拖曳
            if (this.resizeOrigin % 2 == 0) {
                predictWidth = this.width - deltaX;
            } else {
                predictWidth = this.width + deltaX;
                if(this.left + predictWidth > store.baseSize.width - store.toolbarWidth) {
                    predictWidth = store.baseSize.width - store.toolbarWidth - this.left;
                }
            }
            // 從上邊拖曳
            if (this.resizeOrigin < 2) {
                predictHeight = this.height - deltaY;
            } else {
                predictHeight = this.height + deltaY;
                if(this.top + predictHeight > store.baseSize.height - store.toolbarHeight) {
                    predictHeight = store.baseSize.height - store.toolbarHeight - this.top;
                }
            }
            // 設定A檔拖曳放大到邊界的限制
            // if(this.left == 0) {
            //     console.log("1")
            //     predictWidth = this.width + this.left;
            // }
            
            //固定比例縮放
            if (predictWidth / predictHeight > this.windowRatio) {
                predictWidth = this.originWidth * predictHeight / this.originHeight;
            } else {
                predictHeight = this.originHeight * predictWidth / this.originWidth;
            }
            deltaX = this.width - predictWidth;
            deltaY = this.height - predictHeight;


            if (predictWidth > this.AFileWindowMaxWidth * this.minScale / windowContentScaleX.value) {
                if (this.resizeOrigin % 2 == 0) {
                    predictLeft = this.left + deltaX;

                    if(predictLeft < 0) {
                        predictLeft = 0;
                        return;
                    }
                }else {
                    if(predictWidth > this.AFileWindowMaxWidth / windowContentScaleX.value) {
                        predictWidth = this.AFileWindowMaxWidth / windowContentScaleX.value;
                    }
                }
                
            } else {
                predictWidth = this.AFileWindowMaxWidth * this.minScale / windowContentScaleX.value;
                if (this.resizeOrigin % 2 == 0) {
                    predictLeft = this.left + (this.width - (this.AFileWindowMaxWidth * this.minScale) / windowContentScaleX.value);
                }
            }

            if (predictHeight > store.globalPaintData.height * this.minScale ) {
                if (this.resizeOrigin < 2) {
                    predictTop = this.top + deltaY;

                    if(predictTop < 0) {
                        predictTop = 0;
                    }
                }else {
                    if(predictHeight > this.AFileWindowMaxHeight / windowContentScaleY.value) {
                        predictHeight = this.AFileWindowMaxHeight / windowContentScaleY.value;
                    }
                }


            } else {
                predictHeight = store.globalPaintData.height * this.minScale;

                if (this.resizeOrigin < 2) {
                    predictTop = this.top + (this.height - (this.AFileWindowMaxHeight * this.minScale) / windowContentScaleY.value);
                }
            }
            this.$emit("windowResize", predictLeft, predictTop, predictWidth, predictHeight);
        },
        endDragAfileSize: function () {
            document.removeEventListener(EVENT_TYPE.get(this.pointerType + ":move"), this.dragAfileSize);
            document.removeEventListener(EVENT_TYPE.get(this.pointerType + ":up"), this.endDragAfileSize);
            this.maximum = false;
        },
        handleWindow: function () {
            afileStore.immediatelyScale = false;
            this.maximum = !this.maximum;
            afileStore.maximum = this.maximum;
            bookPageStore.isHidden = this.maximum;
            if(this.maximum) {
                AFileControl.getInstance().topAfile(this.AFileConfig);
            }
            this.resize();
        },
        resize() {
            if (settingStore.isFixed == 0) {
                if (this.maximum) {
                    console.log(1);
                    this.top = 0;
                    this.left = store.globalPaintData.margin;
                    this.width = store.globalPaintData.width;
                    this.height = store.globalPaintData.height;
                } else {
                    this.top = store.globalPaintData.height / 4;
                    this.left = store.globalPaintData.width / 4 + store.globalPaintData.margin;
                    this.width = store.globalPaintData.width / 2;
                    this.height = store.globalPaintData.height / 2;
                }
            } else {
                if (this.maximum) {
                    console.log(2);
                    this.top = 0;
                    this.left = 0;
                    this.width = store.pageWidth;
                    this.height = store.pageHeight;
                } else {
                    this.top = store.globalPaintData.height / 4;
                    this.left = store.globalPaintData.width / 4 + store.globalPaintData.margin;
                    this.width = store.pageWidth / 2;
                    this.height = store.pageHeight / 2;
                }
            }
            this.$emit("windowResize", this.left, this.top, this.width, this.height);
        },
        closeAFile: function () {
            window.currentPageItemControl = focusStore.mainBookPageItemControl.itemControl;
            focusStore.setNowPageItemControl();
            if(window.soundManager.currentPlayPage == PAGE_TAG.AFILE) {
                window.soundManager.audioPlayerStop();
            }
            EventBus.getInstance().emit("removeAfile", this.AFileConfig);
            EventBus.getInstance().getAppRefs().textBox.isDirectionBarShow(false);
            PainterProxy.getInstance().removeCurrentPainter();
            afileStore.maximum = false;
        },
        setOriginSize(width, height) {
            this.originWidth = width;
            this.originHeight = height;
        }
    },
    computed: {
        windowBtnClass() {
            return this.maximum == true ? 'windowed' : 'maximum';
        },
        windowRatio() {
            let ratio = parseFloat((this.originWidth / this.originHeight).toFixed(2)) + 0.01;
            return ratio;
        },
        AFileWindowMaxWidth () {
            return (settingStore.isFixed == 0 ? store.globalPaintData.width : store.pageWidth) * windowContentScaleX.value;
        },
        AFileWindowMaxHeight () {
            return (settingStore.isFixed == 0 ? store.globalPaintData.height : store.pageHeight) * windowContentScaleY.value;
        }
    },
    watch: {
        "store.globalPaintData": {
            handler: function () {
                this.maxWidth = store.globalPaintData.width;
                this.maxHeight = store.globalPaintData.height;
            }
        }
    },
    mounted() {
        if (this.AFileConfig.type == "afileMovie") {
            this.minScale = MIN_WINDOW_SCALE.AFILE_MOVIE;
        } else if (this.AFileConfig.type == "afileImage") {
            this.minScale = MIN_WINDOW_SCALE.AFILE_IMAGE;
        } else {
            this.minScale = MIN_WINDOW_SCALE.AFILE;
        }
    }
}
</script>
<style></style>